import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppLayoutComponent } from './app-layout/app-layout.component';
import { RouterModule, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { IconModule } from '../shared/icon/icon.module';

@NgModule({
  declarations: [
    AppLayoutComponent,
    HeaderComponent,
    SidebarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    RouterOutlet,
    FormsModule,
    IconModule
  ],
  exports: [
    //LoadingComponent
  ],
  providers: [Title],
})
export class LayoutsModule { }
